var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.58317V7.6665C6.25 4.49442 7.29167 1.9165 12.5 1.9165C17.7083 1.9165 18.75 4.49442 18.75 7.6665V9.58317M9.89583 15.3332C9.89583 15.9686 10.1702 16.578 10.6586 17.0273C11.147 17.4766 11.8093 17.729 12.5 17.729C13.1907 17.729 13.853 17.4766 14.3414 17.0273C14.8298 16.578 15.1042 15.9686 15.1042 15.3332C15.1042 14.6978 14.8298 14.0884 14.3414 13.6391C13.853 13.1898 13.1907 12.9373 12.5 12.9373",
    stroke: "#0B0A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 16.2918V14.3752C22.9166 10.5418 21.875 9.5835 17.7083 9.5835H7.29165C3.12498 9.5835 2.08331 10.5418 2.08331 14.3752V16.2918C2.08331 20.1252 3.12498 21.0835 7.29165 21.0835H17.7083C19.5416 21.0835 20.7708 20.9014 21.5729 20.3647",
    stroke: "#0B0A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.8caba44d272053aa36b7afe392bd9cfa.svg";
export { ForwardRef as ReactComponent };